import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidaCompleta from "@/pages/article/guida-completa/page";
import DynamicArticle from "@/pages/article/dynamic/page";
import GuidaShopping from "@/pages/guida-shopping/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articolo/guida-completa-itaobuy-spreadsheet",
    element: <GuidaCompleta />,
  },
  {
    path: "/articolo/:slug",
    element: <DynamicArticle />,
  },
  {
    path: "/guida-shopping",
    element: <GuidaShopping />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;